import React, { useEffect, useReducer, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import reducer from '@hooks/useAuth/reducer';
import useSessionStorage from '@hooks/useSessionStorage';
import axiosInstance from '@services/axiosInstance';
import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import moment from 'moment';
import _get from 'lodash/get';
import _trimStart from 'lodash/trimStart';
import { AuthContext } from './context';
import { PATHS } from '../../Routes';
// import Window from 'components/Alert/AlertForm'

// Política de cambio de clave de la respuesta del TRICOR001. Los campos pueden
// venir en la raíz o anidados en un objeto de política junto a mustUpdatePassword.
// Con clave temporal del IVR trae además AuthenticationToken (processId para el
// TRICOR005) o, si el cliente no tiene clave dinámica, un message para mostrar.
function getPasswordPolicy(loginResponse) {
  const response = loginResponse || {};
  const policy =
    Object.values(response).find(
      (value) =>
        value && typeof value === 'object' && 'mustUpdatePassword' in value
    ) || response;
  return {
    mustUpdatePassword: _get(policy, 'mustUpdatePassword') === true,
    shouldUpdatePassword: _get(policy, 'shouldUpdatePassword') === true,
    authenticationToken:
      _get(policy, 'AuthenticationToken') ||
      _get(policy, 'authenticationToken') ||
      null,
    message: _get(policy, 'message') || null,
  };
}

AuthProvider.propTypes = {
  children: PropTypes.any,
};

// eslint-disable-next-line
export default function AuthProvider({ children }) {
  const { push } = useHistory();
  const { pathname } = useLocation();
  const [, setSession] = useSessionStorage('session', null);
  const [profile, setProfile] = useSessionStorage('profile', {});
  const [ready, setReady] = useState(false);
  const [accessToken, setAccessToken] = useSessionStorage('accessToken', null);
  const [customerKey, setCustomerKey] = useSessionStorage('customerKey', null);

  const [state, dispatch] = useReducer(reducer, {
    profile,
    customerKey,
    accessToken,
    isAuthenticated: accessToken && customerKey && _get(profile, 'id'),
    time: moment().format('DD-MM-YYYY, HH:mm'),
  });
  const currentProfileId =
    _trimStart(_get(Cookies.get(), 'CustomerId'), '0') ||
    _get(state, 'profile.id', '');
  // recupero respuesta de servicio tricor01 con la Cookie "CustomerKey"
  const currentCustomerKey =
    _get(Cookies.get(), 'CustomerKey') || _get(state, 'customerKey', null);
  const currentAccessToken =
    _get(Cookies.get(), 'AccessToken') || _get(state, 'accessToken', null);
  // creo una constante para convertir la respuesta del servicio tricor01 para obtener sus datos y utilizarlos
  const loginResponse = JSON.parse(currentCustomerKey);
  const passwordPolicy = getPasswordPolicy(loginResponse);

  const updateAuthProfile = async ({ profileId, customerKey, accessToken }) => {
    axiosInstance.defaults.headers.common['customer-key'] = customerKey;
    axiosInstance.defaults.headers.common.Authorization = `bearer ${accessToken}`;
    const response = await axiosInstance.get(`/v1/customers/${profileId}`);
    const updatedProfile = Object.assign(
      {},
      _get(state, 'profile', {}),
      _get(response, 'data.customer', {}),
      {
        id: profileId,
        identificationNumber: _trimStart(
          _get(response, 'data.customer.identificationNumber', ''),
          '0'
        ),
        executiveCode: 1234, // Código ejecutivo
        branchCode: 711, // Código sucursal
      }
    );
    setProfile(updatedProfile);
    // actualizo el customerKey con la respuesta del servicio y el dato respectivo del token
    setCustomerKey(loginResponse.token);
    setAccessToken(accessToken);
    setSession({ accessToken });
    await dispatch({
      action: 'update',
      values: {
        accessToken,
        customerKey,
        profile: updatedProfile,
        passwordPolicy,
        isAuthenticated:
          accessToken && customerKey && _get(updatedProfile, 'id'),
        time: moment().format('DD-MM-YYYY, HH:mm'),
      },
    });
  };

  useEffect(() => {
    // eslint-disable-next-line max-statements
    const handleAuth = async () => {
      try {
        if (currentProfileId) {
          await updateAuthProfile({
            profileId: currentProfileId,
            accessToken: currentAccessToken,
            // actualizo el customerKey con la respuesta del servicio y el dato respectivo del token
            customerKey: loginResponse.token,
            time: moment().format('DD-MM-YYYY, HH:mm'),
          });
          if (['/', PATHS.AUTH].includes(pathname)) {
            push(PATHS.HOME);
          }
          if (passwordPolicy.mustUpdatePassword) {
            push(PATHS.MUSTUPDATEPASSWORD);
          } else if (passwordPolicy.shouldUpdatePassword) {
            push(PATHS.MUSTUPDATEPASSWORD);
          }
        } else {
          setProfile({});
        }
      } catch (e) {
        setSession(null);
        dispatch({ action: 'reset' });
      }
    };

    handleAuth();
    // eslint-disable-next-line
  }, [currentProfileId]);

  useEffect(() => {
    setReady(true);

    // if (profile.campaignCode === 2) {
    //   setIsWindowVisible(true)
    // }
  }, []);

  // const [isWindowVisible, setIsWindowVisible] = useState(false)

  // const closeWindow = () => {
  //   setIsWindowVisible(false)
  // }

  return (
    <AuthContext.Provider value={[state, dispatch]}>
      {/* {isWindowVisible && <Window open={ isWindowVisible === true } onClose={closeWindow} />} */}
      {ready ? children : []}
    </AuthContext.Provider>
  );
}
